import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';

type PopundersStateType = {
  isFetching: boolean;
  popunders: string[];
};
type PopundersReducers = {
  fetchPopundersStartAction: CaseReducer<PopundersStateType>;
  fetchPopundersSuccessAction: CaseReducer<
    PopundersStateType,
    PayloadAction<PopundersStateType['popunders']>
  >;
};

const defaultState: PopundersStateType = {
  isFetching: false,
  popunders: [],
};

const popunders = createSlice<
  PopundersStateType,
  PopundersReducers,
  'popunders',
  never
>({
  initialState: defaultState,
  name: 'popunders',
  reducers: {
    fetchPopundersStartAction: (state) => ({ ...state, isFetching: true }),
    fetchPopundersSuccessAction: (state, { payload }) => ({
      ...state,
      popunders: payload,
      isFetching: false,
    }),
  },
});

export const { fetchPopundersStartAction, fetchPopundersSuccessAction } =
  popunders.actions;

export default popunders.reducer;
